import * as Constants from '../utilities/constants/Constants';
import React from 'react';
import actions from './actionTypes';
import { toolBarRerender } from './fabricCanvasActions';

export const handleZoomInForCanvas = opt => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;

  let zoom = wallCanvas.getZoom();
  zoom += Constants.ZOOM_SCALE_FACTOR;
  if (zoom > 20) zoom = 20;

  wallCanvas.setZoom(zoom);

  if (opt) {
    opt.e.preventDefault();
    opt.e.stopPropagation();
  }

  dispatch(toolBarRerender());
  wallCanvas.renderAll();
  dispatch(renderRuler());
};

export const handleZoomOutForCanvas = opt => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;

  let zoom = wallCanvas.getZoom();
  zoom -= Constants.ZOOM_SCALE_FACTOR;
  if (zoom < 1) {
    dispatch(resetZoomState());
    dispatch(toolBarRerender());
    return;
  }
  dispatch(toolBarRerender());

  if (opt) {
    opt.e.preventDefault();
    opt.e.stopPropagation();
  }

  wallCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
  wallCanvas.setZoom(zoom);

  wallCanvas.renderAll();
  dispatch(renderRuler());
};

export const renderRulerCanvasHorizontal = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const width = wallCanvas ? wallCanvas.width : 0;
  return (
    <canvas
      id='outerCanvasHorizontal'
      width={width}
      height={Constants.RULER_SIZE}
    />
  );
};

export const renderRulerCanvasVertical = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const height = wallCanvas ? wallCanvas.height : 0;
  return (
    <canvas
      id='outerCanvasVertical'
      width={Constants.RULER_SIZE}
      height={height}
    />
  );
};

export const drawOuterCanvasHorizontal = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const outerCanvasHorizontal = document.getElementById(
    'outerCanvasHorizontal'
  );
  let maxWidth = getState().home.projectWidth;
  const unitSystemType = getState().home.unitSystem;
  let incrementalXIndex = 1;

  if (unitSystemType === Constants.METRIC_KEY) {
    maxWidth *= Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;
  }
  if (maxWidth > 100) {
    incrementalXIndex = Math.round(maxWidth / 100);
  }

  if (outerCanvasHorizontal) {
    const ctx2 = outerCanvasHorizontal.getContext('2d');
    ctx2.clearRect(
      0,
      0,
      outerCanvasHorizontal.clientWidth,
      outerCanvasHorizontal.clientHeight
    );
    ctx2.save();
    const pixelsPerInch =
      (dispatch(usableFrame(wallCanvas)) * wallCanvas.getZoom()) /
      getState().home.projectHeight;
    ctx2.beginPath();
    ctx2.font = '12px/14px Arial, sans-serif';

    let x = 0;
    const y = Constants.RULER_SIZE;
    ctx2.moveTo(x, y);
    ctx2.lineTo(x, y - Constants.RULER_LARGE);

    let ppi = pixelsPerInch;
    if (unitSystemType == Constants.METRIC_KEY) {
      ppi = pixelsPerInch / Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;
    }

    const rulerStartPoint =
      incrementalXIndex - wallCanvas.viewportTransform[4] / ppi;

    let roundUpValue = Math.round(rulerStartPoint);
    if (rulerStartPoint % incrementalXIndex !== 0) {
      roundUpValue = Math.round(
        rulerStartPoint +
          incrementalXIndex -
          (rulerStartPoint % incrementalXIndex)
      );
    }

    const rulerStartLinePoint =
      incrementalXIndex + roundUpValue - rulerStartPoint;

    for (
      let i = roundUpValue, pos = rulerStartLinePoint;
      i <= maxWidth;
      i += incrementalXIndex, pos += incrementalXIndex
    ) {
      x = pos * ppi;

      if (i % 10 === 0) {
        ctx2.moveTo(x, y - Constants.RULER_LARGE);
        ctx2.fillText(i, x - 18, 16);
      } else if (i % 5 === 0) {
        ctx2.moveTo(x, y - Constants.RULER_MEDIUM);
      } else {
        ctx2.moveTo(x, y - Constants.RULER_SMALL);
      }
      ctx2.lineTo(x, y);
    }
    ctx2.stroke();
    ctx2.restore();
  }
};

export const drawOuterCanvasVertical = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const outerCanvasVertical = document.getElementById('outerCanvasVertical');
  let maxHeight = getState().home.projectHeight;
  const unitSystemType = getState().home.unitSystem;
  let incrementalYIndex = 1;

  if (unitSystemType === Constants.METRIC_KEY) {
    maxHeight *= Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;
  }
  if (maxHeight > 100) {
    incrementalYIndex = Math.round(maxHeight / 100);
  }

  if (outerCanvasVertical) {
    const ctx = outerCanvasVertical.getContext('2d');
    ctx.clearRect(
      0,
      0,
      outerCanvasVertical.clientWidth,
      outerCanvasVertical.clientHeight
    );
    ctx.save();

    const pixelsPerInch =
      (dispatch(usableFrame(wallCanvas)) * wallCanvas.getZoom()) /
      getState().home.projectHeight;
    ctx.beginPath();
    ctx.font = '12px/14px Arial, sans-serif';
    let y = 0;
    const x = Constants.RULER_SIZE;
    ctx.moveTo(x, y);
    ctx.lineTo(x - Constants.RULER_LARGE, y);

    let ppi = pixelsPerInch;
    if (unitSystemType == Constants.METRIC_KEY) {
      ppi = pixelsPerInch / Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;
    }
    const rulerStartPoint =
      incrementalYIndex - wallCanvas.viewportTransform[5] / ppi;
    let roundUpValue = Math.round(rulerStartPoint);
    if (rulerStartPoint % incrementalYIndex !== 0) {
      roundUpValue = Math.round(
        rulerStartPoint +
          incrementalYIndex -
          (rulerStartPoint % incrementalYIndex)
      );
    }
    const rulerStartLinePoint =
      incrementalYIndex + roundUpValue - rulerStartPoint;
    for (
      let j = roundUpValue, pos = rulerStartLinePoint;
      j <= maxHeight;
      j += incrementalYIndex, pos += incrementalYIndex
    ) {
      y = pos * ppi;

      if (j % 10 == 0) {
        ctx.moveTo(x - Constants.RULER_LARGE, y);
        ctx.fillText(j, 0, y);
      } else if (j % 5 == 0) {
        ctx.moveTo(x - Constants.RULER_MEDIUM, y);
      } else {
        ctx.moveTo(x - Constants.RULER_SMALL, y);
      }
      ctx.lineTo(x, y);
    }
    ctx.stroke();
    ctx.restore();
  }
};

export const handleZoomIn = () => dispatch => {
  dispatch({
    type: actions.ZOOM_IN_MODE,
    payload: {
      value: true
    }
  });
  dispatch({
    type: actions.ZOOM_OUT_MODE,
    payload: {
      value: false
    }
  });
  dispatch(handleZoomInForCanvas());
};

export const handleZoomOut = () => dispatch => {
  dispatch({
    type: actions.ZOOM_OUT_MODE,
    payload: {
      value: true
    }
  });
  dispatch({
    type: actions.ZOOM_IN_MODE,
    payload: {
      value: false
    }
  });
  dispatch(handleZoomOutForCanvas());
};

export const resetZoomState = () => dispatch => {
  dispatch(resetZoom());
  dispatch({
    type: actions.ZOOM_IN_MODE,
    payload: {
      value: false
    }
  });

  dispatch({
    type: actions.ZOOM_OUT_MODE,
    payload: {
      value: false
    }
  });
};

export const resetZoom = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  wallCanvas.setZoom(1);
  wallCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
};

export const renderRuler = () => dispatch => {
  dispatch(drawOuterCanvasHorizontal());
  dispatch(drawOuterCanvasVertical());
};

export const usableFrame = wallCanvas => (dispatch, getState) => {
  let usableFrameValue;
  if (wallCanvas) {
    const boundsWidth = wallCanvas.width;
    const boundsHeight = wallCanvas.height;
    const { projectWidth, projectHeight } = getState().home;

    if (hasVerticalAspectRatio(projectWidth, projectHeight)) {
      usableFrameValue = boundsHeight;
    } else {
      const ratio = boundsWidth / projectWidth;
      const modelFrameHeight = ratio * projectHeight;
      usableFrameValue = modelFrameHeight;
    }
  }
  return usableFrameValue;
};

export const hasVerticalAspectRatio = (projectWidth, projectHeight) => {
  const playgroundFrame = document.getElementById('outerCanvas');
  const boundsWidth = playgroundFrame.clientWidth;
  const boundsHeight = playgroundFrame.clientHeight;
  const boundsAspectRatio = boundsWidth / boundsHeight;
  const modelAspectRatio = projectWidth / projectHeight;

  if (boundsAspectRatio > modelAspectRatio) {
    return true;
  }
  return false;
};
